import { Paper, Stack } from "@mui/material";
import { memo } from "react";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton.tsx";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList.tsx";
import type { SelectedCompany, SelectedCompanyDashboard } from "../../../hooks/validationStateSlice.ts";
import type { DashboardValidationType } from "../../hooks/useDashboardValidation.ts";
import CompanyContent from "../CompanyContent.tsx";
import CompanyDashboardListItem from "../CompanyDashboardListItem.tsx";
import CompanyHeader from "../CompanyHeader.tsx";
import { DashboardSummary } from "../DashboardSummary.tsx";
import { TileItemValidation } from "./TileItemValidation.tsx";

interface Props {
  company: SelectedCompany;
  validation: DashboardValidationType;
  companyBranding: ListItemData | undefined;
  Action?: React.ReactElement;
  Summary?: React.ReactElement;
}
const CompanyListItem = ({ company, validation, companyBranding, Action, Summary }: Props) => {
  const handleRemoveDashboard = (companyDashboard: SelectedCompanyDashboard) => {
    validation.removeDashboard(companyDashboard);
  };

  return (
    <Paper variant="outlined" sx={(theme) => ({ borderColor: theme.palette.divider, width: "100%" })}>
      <Stack>
        <CompanyHeader companyBranding={companyBranding} action={Action} />
        <CompanyContent company={company} summary={Summary}>
          {company.dashboards.map((companyDashboard: SelectedCompanyDashboard) => (
            <CompanyDashboardListItem
              key={companyDashboard.dashboard.dashboardId}
              dashboard={companyDashboard.dashboard}
              widgets={companyDashboard.tiles.length}
              Action={
                <CloseIconButton
                  onClick={() => handleRemoveDashboard(companyDashboard)}
                  color="secondary"
                  size="small"
                />
              }
              Summary={<DashboardSummary dashboard={companyDashboard} />}
            >
              {companyDashboard.tiles.map((tile) => (
                <TileItemValidation key={tile.tile.tileId} tile={tile} validation={validation} />
              ))}
            </CompanyDashboardListItem>
          ))}
        </CompanyContent>
      </Stack>
    </Paper>
  );
};

export default memo(CompanyListItem);
